type AppError = {
    body: {
        message: string;
        errors?: {
            [k: string]: string[];
        };
    };
    cause?: {
        status: number;
    };
};
export function isAppError(error: unknown): error is AppError {
    if (!error || typeof error !== 'object') {
        return false;
    }

    const candidate = error as Record<string, unknown>;

    // Check if it has a body property that's an object
    if (!candidate.body || typeof candidate.body !== 'object') {
        return false;
    }

    const body = candidate.body as Record<string, unknown>;

    // Check if body has a message property of type string
    if (typeof body.message !== 'string') {
        return false;
    }

    // Check if body has an errors property that's an object (optional)
    if (typeof body.errors !== 'object' && typeof body.errors !== 'undefined') {
        return false;
    }

    // Check if all values in the errors object are string arrays
    const errors = body.errors as Record<string, unknown> | undefined;
    if (errors === undefined) {
        return true;
    }

    return Object.values(errors).every(
        (value) =>
            Array.isArray(value) &&
            value.every((item) => typeof item === 'string'),
    );
}
